import axios from "axios";

// Grab our environment variables for setup
const API_URL: string = process.env.REACT_APP_API_URL || "/api";
// const API_VERSION: string = process.env.REACT_APP_API_VERSION || "1.0.0";

// Create the API client
const api = axios.create({
	baseURL: API_URL,
});

const API_CSRF =
	process.env.REACT_APP_CSRF && !isNaN(parseInt(process.env.REACT_APP_CSRF))
		? parseInt(process.env.REACT_APP_CSRF)
		: 1;

api.defaults.headers.common["x-axiell-csrftoken"] = API_CSRF;

// HACK: This line only applies to IE11 - it sets a no cache header to all requests to fix
// an IE11 bug where the browser caches api responses by default.
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
if (!!document.documentMode) api.defaults.headers.get["Pragma"] = "no-cache";

export const masonCtlKey = Object.freeze({
	workflow: Object.freeze({
		definitions: "workflow:definitions",
		start: "flow:start-activity",
		myTasks: "workflow:mytasks",
		page: "flow:more",
		unclaimedTasks: "workflow:unclaimedtasks",
	}),
	cursor: Object.freeze({
		create: "cursor:create",
		moveForward: "cursor:moveforward",
	}),
	notifications: Object.freeze({
		page: "notifications:more",
	}),
	tokens: Object.freeze({
		revoke: "tokens:revoke",
	}),
	view: Object.freeze({
		page: "view:more",
	}),
});

export default api;
